angular.module('rjmNg.directives').directive "sqlMessage", [
  () ->
    restrict: "E"
    templateUrl: "directive.sqlMessage.html"
    replace: false
    controllerAs: "view"
    bindToController: true
    scope:
      status: "="
      message: "="
    controller: [
      "queryStatus"
      (
        queryStatus
      ) ->

        view = @
        view.colorMap = {}
        view.colorMap[queryStatus.ERROR] = 'text-error'
        view.colorMap[queryStatus.WARNING] = 'text-warning'
        view.colorMap[queryStatus.SUCCESS] = 'text-success'

        view.statusColor = view.colorMap[queryStatus.SUCCESS]

        return view
    ]
    link: (scope, elem, attrs) ->
      scope.$watch "view.status", (status) ->
        scope.view.statusColor = scope.view.colorMap[status]
]
